import About from '../components/About';
import Services from '../components/Services';
import Providers from '../components/Providers';
import Contact from '../components/Contact';
import Pricing from '../components/pricing';

function Main() {
  return (
    <>
      <main>
      <Providers />
      <Pricing />
        
        
        <Services />
        <About />
        <Contact />
        
        
      </main>
    </>
  );
}
export default Main;
